import React, { Component } from 'react';
import { connect as reduxConnect } from 'react-redux';
import { connect } from '../../../base/connection/actions.web';
import { toJid } from '../../../base/connection/functions';
import { translate, translateToHTML } from '../../../base/i18n/functions';
import { JitsiConnectionErrors } from '../../../base/lib-jitsi-meet';
import Dialog from '../../../base/ui/components/web/Dialog';
import { authenticateAndUpgradeRole, cancelLogin } from '../../actions.web';
import { Box, Checkbox, Typography } from '@mui/material';
// @ts-ignore
import { LINK_JITSIMEET, PAGE_LOGIN, URL_POLICY } from '../../../../../modules/API';
// @ts-ignore
import { setTokens } from '../../../base/util/cookies';
/**
 * Component that renders the login in conference dialog.
 *
 *  @returns {React$Element<any>}
 */
class LoginDialog extends Component {
    /**
     * Initializes a new {@code LoginDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.storeGuestData = async (token, refreshToken) => {
            localStorage.setItem("joinAsGuest", "yes");
            setTokens(token, refreshToken);
        };
        this.state = {
            username: '',
            password: '',
            agreePolicy: false
        };
        this._onCancelLogin = this._onCancelLogin.bind(this);
        this._onLogin = this._onLogin.bind(this);
        this._onUsernameChange = this._onUsernameChange.bind(this);
        this._onPasswordChange = this._onPasswordChange.bind(this);
    }
    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onCancelLogin() {
        const { dispatch } = this.props;
        dispatch(cancelLogin());
    }
    /**
     * Notifies this LoginDialog that the login button (OK) has been pressed by
     * the user.
     *
     * @private
     * @returns {void}
     */
    _onLogin() {
        const { _conference: conference, _configHosts: configHosts, dispatch } = this.props;
        const { password, username } = this.state;
        const jid = toJid(username, configHosts ?? {
            authdomain: '',
            domain: ''
        });
        if (conference) {
            dispatch(authenticateAndUpgradeRole(jid, password, conference));
        }
        else {
            dispatch(connect(jid, password));
        }
    }
    /**
     * Callback for the onChange event of the field.
     *
     * @param {string} value - The static event.
     * @returns {void}
     */
    _onPasswordChange(value) {
        this.setState({
            password: value
        });
    }
    /**
     * Callback for the onChange event of the username input.
     *
     * @param {string} value - The new value.
     * @returns {void}
     */
    _onUsernameChange(value) {
        this.setState({
            username: value
        });
    }
    /**
     * Renders an optional message, if applicable.
     *
     * @returns {ReactElement}
     * @private
     */
    renderMessage() {
        const { _configHosts: configHosts, _connecting: connecting, _error: error, _progress: progress, t } = this.props;
        const { username, password } = this.state;
        const messageOptions = {};
        let messageKey;
        if (progress && progress < 1) {
            messageKey = 'connection.FETCH_SESSION_ID';
        }
        else if (error) {
            const { name } = error;
            if (name === JitsiConnectionErrors.PASSWORD_REQUIRED) {
                const { credentials } = error;
                if (credentials
                    && credentials.jid === toJid(username, configHosts ?? { authdomain: '',
                        domain: '' })
                    && credentials.password === password) {
                    messageKey = 'dialog.incorrectPassword';
                }
            }
            else if (name) {
                messageKey = 'dialog.connectErrorWithMsg';
                messageOptions.msg = `${name} ${error.message}`;
            }
        }
        else if (connecting) {
            messageKey = 'connection.CONNECTING';
        }
        if (messageKey) {
            return (React.createElement("span", null, translateToHTML(t, messageKey, messageOptions)));
        }
        return null;
    }
    loginJoin(e) {
        e.preventDefault();
        const roomName = window.location.pathname.split("/")[1];
        const url = PAGE_LOGIN + "?domain=" + LINK_JITSIMEET + '/' + roomName;
        window.location.href = url;
        window.location.assign(url);
        location.replace(url);
    }
    async guestJoin() {
        // const roomName = window.location.pathname.split("/")[1]
        // try {
        //     const result = await ApiManagerUser.guestJoin(roomName)
        //     if(result.data?.token) {
        //         this.storeGuestData(result.data?.token, result.data?.refreshToken)
        //         setTimeout(() => {
        //             window.location.reload()
        //         }, 1000);
        //     }
        // } catch (error:any) {
        //     if(error.response?.data?.data) {
        //         switch (error.response?.data?.data) {
        //             case 'ROOM_NOT_START':
        //                 alert(localStorage.getItem('language') === "vi" ? "Cuộc họp không tồn lại, hoặc chưa diễn ra. Vui lòng liên hệ lại chủ trì." : "The meeting doesn't exist, or hasn't happened yet. Please contact the host again.")
        //                 break;
        //             case 'RETRY':
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 1000);
        //                 break;
        //             default:
        //                 alert(localStorage.getItem('language') === "vi" ? "Xin thử lại" : "Try again")
        //                 console.log("ERR: ", error.response);
        //                 break;
        //         }
        //     }
        // }
    }
    handleEnterPress(e, callback) {
        e.preventDefault();
        if (e.nativeEvent.code === "Enter") {
            callback();
        }
    }
    /**
     * Implements {@Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _connecting: connecting, t } = this.props;
        const { password, username } = this.state;
        return (React.createElement(Dialog, { disableAutoHideOnSubmit: true, disableBackdropClose: true, hideCloseButton: false, hideButtons: true, ok: {
                disabled: connecting
                    || !password
                    || !username,
                translationKey: 'dialog.login'
            }, onCancel: this._onCancelLogin, onSubmit: this._onLogin, className: 'dialog-login' },
            React.createElement(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', className: 'join-meeting' },
                React.createElement("img", { src: '../../../../../images/logo.png?v=250630', width: "150px" }),
                React.createElement(Typography, { sx: { padding: '32px 0', fontWeight: 600, textAlign: 'center' }, className: 'title-join-meeting' },
                    React.createElement("span", null, t('guest.intro1')),
                    React.createElement("span", { style: { display: 'block' } }, t('guest.intro2', { appName: interfaceConfig.APP_NAME || "Viettel Meeting" }))),
                React.createElement("div", { className: 'footer-join-meeting' },
                    React.createElement("div", { className: 'create-account-policy' },
                        React.createElement(Checkbox, { checked: this.state.agreePolicy, onChange: e => this.setState({ agreePolicy: e.target.checked }), onKeyDown: e => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.setState({ agreePolicy: !this.state.agreePolicy });
                                }
                            } }),
                        React.createElement("span", null,
                            t('policy.i-agree'),
                            React.createElement("span", { className: 'spotline', onClick: () => window.open(URL_POLICY) }, t('policy.terms-conditions')),
                            t('policy.and'),
                            React.createElement("span", { className: 'spotline', onClick: () => window.open(URL_POLICY) }, t('policy.privacy-policy')))),
                    React.createElement("span", { style: { alignSelf: 'center' }, tabIndex: 1, className: `join-as-guest ${!this.state.agreePolicy ? 'join-as-guest-disabled' : ''}`, onClick: () => {
                            if (this.state.agreePolicy) {
                                this.guestJoin();
                            }
                        }, onKeyPress: (e) => this.handleEnterPress(e, this.guestJoin) }, t('guest.guestJoin')),
                    React.createElement("button", { tabIndex: 1, className: 'btn-join-meeting btn-join-meeting-login', onClick: (e) => this.loginJoin(e), onKeyPress: (e) => this.handleEnterPress(e, (e) => this.loginJoin(e)) }, t('guest.login'))))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code LoginDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function mapStateToProps(state) {
    const { error: authenticateAndUpgradeRoleError, progress, thenableWithCancel } = state['features/authentication'];
    const { authRequired, conference } = state['features/base/conference'];
    const { hosts: configHosts } = state['features/base/config'];
    const { connecting, error: connectionError } = state['features/base/connection'];
    return {
        _conference: authRequired || conference,
        _configHosts: configHosts,
        _connecting: Boolean(connecting) || Boolean(thenableWithCancel),
        _error: connectionError || authenticateAndUpgradeRoleError,
        _progress: progress
    };
}
export default translate(reduxConnect(mapStateToProps)(LoginDialog));
